<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="班组"
      edit-title
      id-key="TeamId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row :gutter="15">
            <el-col>
              <el-form-item label="班组名称" prop="Team">
                <el-input v-model="data.Team" placeholder="请输入名称" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- h -->
          <el-row :gutter="15">
            <el-col>
              <el-form-item label="部门" prop="DpId">
                <!-- <el-select v-model="data.DpId" clearable>
                  <el-option
                    v-for="(item, index) in dpList"
                    :key="index"
                    :value="item.DpId"
                    :label="item.DpName"
                  ></el-option>
                </el-select> -->
                <v-select style="width: 180px" ref="typeSelect" v-model="data.DpId" @node-click="nodeClick" clearable/>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- h -->

          <el-row :gutter="15">
            <el-col>
              <el-form-item label="工价类型" prop="TeamType">
                <el-select v-model="data.TeamType">
                  <el-option label="计时" :value="0"></el-option>
                  <el-option label="计件" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col>
              <el-form-item label="对应班次" prop="ScheduleId">
                <!-- <el-input v-model="data.Team" placeholder="请输入名称" /> -->
                <el-select v-model="data.ScheduleId">
                  <el-option
                    v-for="(item, index) in scheduleList"
                    :key="index"
                    :value="item.ScheduleId"
                    :label="item.Schedule"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col>
              <el-form-item label="序号" prop="Sn">
                <el-input v-model="data.Sn" v-int style="width: 100px" />
                <span class="t-tips">*值越小排得越前</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <div class="row-tb-head" style="margin-top: 10px">
          <span>班组成员</span>
          <div style="float: right">
            <el-button type="primary" @click="openEmpDialog" v-if="!editLoading">添加</el-button>
            <el-button type="danger" @click="del">删除</el-button>
          </div>
        </div>
        <el-table
          ref="table"
          row-key="EmpId"
          class="table-line tb-c-head"
          @selection-change="handleSelectionChange"
          :data="empList"
          border
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            prop="EmpName"
            label="人员名称"
            min-width="110"
            align="center"
          />
        </el-table>
        <!-- h -->
        <!-- <span class="text-gray">{{this.IdChain}}</span>  -->
      </template>
      <emp-dialog
        ref="empDialog"
        in-dialog
        selectable
        multiple
        @select-multiple="setEmp"
        :modelType="dialogModel"
        :IdChain="IdChain"
      />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
//import empDialog from "@/components/personnel/result/record/listDialog";  // <!-- h -->
import empDialog from "@/components/personnel/result/record/listDialogEx";  // <!-- h -->
import vSelect from '@/components/business/stock/productionpicking/vSelect' // <!-- h -->

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog,
    vSelect, // <!-- h -->
  },
  data() {
    return {
      dialogModel: "personnelresultrecord",
      dpList: [],
      data: {
        TeamId: 0,
        Team: "",
        ScheduleId: "",
        EndTime: "",
        DetailDtos: [],
        Sn:null,
        TeamType:null,
        DpId: null, // <!-- h -->
      },
      IdChain: null, // <!-- h -->
      editLoading: false, // <!-- h -->
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/team").default,
      dpApi: require('@/api/ent/dp').default,
      scheduleApi: require("@/api/ba/schedule").default,
      showList: [],
      scheduleList: [],
      empList: [],
      multipleSelection: [],
      rules: {
        Team: [{ required: true, message: "班组名称不能为空" }],
        // ScheduleId: [{ required: true, message: "对应班次不能为空" }],
        Sn: [{ required: true, message: "序号不能为空" }],
        TeamType: [{ required: true, message: "工价类型不能为空" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {

      // <!-- h -->
      //console.log("onOpened");
      this.dpApi.list({ Status: 1 }).then(res => {
        console.log("dp", res.Data);
        this.dpList = res.Data
      })
      // <!-- h -->

      this.scheduleApi.list({}).then((res) => {
        console.log("res", res);
        this.scheduleList = res.Data;
      });


    },

    onEditOpened(data) {
      // <!-- h -->
      this.IdChain = null;

      if (data.DpId) {
        this.editLoading = true;
        this.dpApi.list({Id: data.DpId}).then(res => {
          if (res.Data[0]) {
            this.$set(this, 'IdChain', res.Data[0].IdChain);
          }
          this.editLoading = false;
          console.log("onEditOpened2", data, this.IdChain)
        });
      }        
      // <!-- h -->
            


      this.api.info(this.data.TeamId).then((res) => {
        this.empList = res.Data.DetailDtos.reduce((arr, item) => {
          arr.push({ EmpId: item.EmpId, EmpName: item.EmpName });
          return arr;
        }, []);
        this.data = res.Data;
      });


    },
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
    onBeforeSave() {
      // this.$message.warning('每个员工只能加入一个班组,该功能后续完善')
      if (this.data.DetailDtos.length == 0) this.data.DetailDtos = this.empList;
      else {
        let delIds = this.empList.map((item) => item.EmpId);
        let delList = this.data.DetailDtos.reduce((arr, item) => {
          if (!delIds.includes(item.EmpId)) arr.push({ ...item, T: 2 });
          return arr;
        }, []);

        let addIds = this.data.DetailDtos.map((item) => item.EmpId);
        let addList = [];
        addList = this.empList.reduce((arr, item) => {
          if (!addIds.includes(item.EmpId)) arr.push({ ...item, T: 0 });
          return arr;
        }, []);

        this.data.DetailDtos = [...addList, ...delList];
        console.log(this.data.DetailDtos);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    openEmpDialog() {
      this.$refs.empDialog.open();
    },
    del() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let delList = this.multipleSelection.map((item) => item.EmpId);
          let data = this.empList.filter(
            (item) => !delList.includes(item.EmpId)
          );
          this.empList = JSON.parse(JSON.stringify(data));
        })
        .catch(() => {});
    },

    setEmp(emp) {
      // console.log(emp);
      let empId = this.empList.map((item) => item.EmpId);
      emp.forEach((item) => {
        if (!empId.includes(item.EmpId))
          this.empList.push({ EmpId: item.EmpId, EmpName: item.EmpName });
      });

      // this.data.EmpId = emp.EmpId;
      // this.data.EmpName = emp.EmpName;
      // this.data.EmpNo = emp.EmpNo;
      // this.data.DpId = emp.DpId;
      // this.data.DpName = emp.DpName;
    },
    onClosed() {
      this.showList = [];

      this.scheduleList = [];
      this.empList = [];
      this.multipleSelection = [];

      this.$refs.typeSelect.clear(); // <!-- h -->
    },
    nodeClick(e) { // <!-- h -->
      //console.log('nodeClick', e);
      this.IdChain = e.IdChain;
    },
  },
};
</script>
